import { useNavigate } from 'react-router';

import TitleAndImageWrapper from '../../components/layout/TitleAndImageLayout';
import { routes } from '../../constants/Constants';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <TitleAndImageWrapper
      name="Error"
      title="404 Error"
      subtitle="Something went wrong. The page you are looking for could not be found."
      clickFuntion={() => navigate(routes.propertyEnrollmentForm)}
      buttonName="Back to Homepage"
    />
  );
};

export default ErrorPage;
